import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PetImage2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.25 21.75H9.75V24H8.25V21.75ZM8.25 6H9.75V8.25H8.25V6ZM0 14.25H2.25V15.75H0V14.25ZM15.75 14.25H18V15.75H15.75V14.25ZM2.11492 9.17475L3.16492 8.12475L4.75642 9.7155L3.70642 10.7655L2.11492 9.17475ZM13.2563 20.2995L14.3063 19.2495L15.897 20.841L14.847 21.891L13.2563 20.2995ZM2.12324 20.8425L3.71399 19.2525L4.76399 20.3025L3.17399 21.8925L2.12324 20.8425ZM13.248 9.70277L14.8387 8.11202L15.8887 9.16202L14.298 10.7528L13.248 9.70277ZM9 9.75C6.1005 9.75 3.75 12.1005 3.75 15C3.75 17.8995 6.1005 20.25 9 20.25C11.8995 20.25 14.25 17.8995 14.25 15C14.25 12.1005 11.8995 9.75 9 9.75ZM9 18.75C6.92893 18.75 5.25 17.0711 5.25 15C5.25 12.9289 6.92893 11.25 9 11.25V18.75ZM1.5 1.5H6.75V0H0V6.75H1.5V1.5ZM22.5 0H19.5C18.6716 0 18 0.671573 18 1.5V9C18 9.82843 18.6716 10.5 19.5 10.5H22.5C23.3284 10.5 24 9.82843 24 9V1.5C24 0.671573 23.3284 0 22.5 0ZM19.5 9V1.5H22.5V9H19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PetImage2.vue"]]);
